module.exports = __webpack_public_path__ + "img/ring_r_i_null_1.a5bcfba4.png";